module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Liencres-be6150f324201b208a0e4eff15dd1d33.jpg";